export default __webpack_public_path__ + "static/mobile-bipolar-73010b614aeaf509b8296dbec9cd76ad.webp";